import { render, staticRenderFns } from "./CommunityChip.vue?vue&type=template&id=16585996&"
import script from "./CommunityChip.vue?vue&type=script&lang=ts&"
export * from "./CommunityChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports